<div id='charts'>
  <div id='dateChart' class='dc-chart'>
    <div class='title'>Filtro por fecha</div>
  </div>
</div>
